const aaSiteId = {
    goldenPages: 0,
    rest: 1,
    mishlohim: 3,
    mithatnim: 4,
    doctors: 7,
    mishpati: 8,
    hoogel: 10,
  };
  
  export default Object.freeze(aaSiteId);